//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MCancelIconName, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import Dialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';
import MCalendar from '../Components/Toolkit/Calendar';

//endregion

/** */
type Props = {
    onDateSelected?: (data: Date | undefined) => void;
}

/** */
type State = {
    prompt: string,
    useLastNote: boolean,
    position?: DialogPositionType;
    visible: boolean;
    selectedDate: Date | undefined;
    maxLength: number;
}

/** */
class NoParkingDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();
    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);

        this.getDialogTemplate = this.getDialogTemplate.bind(this);
        this.getFooterTemplate = this.getFooterTemplate.bind(this);
        this.ok_Click = this.ok_Click.bind(this);
        this.cancel_Click = this.cancel_Click.bind(this);
        this.onDateChange = this.onDateChange.bind(this);

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {
            prompt: '',
            maxLength: 10000,
            useLastNote: false,
            visible: false,
            selectedDate: undefined,
        };
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(position?: DialogPositionType) {
        this.safeSetState((draft: State) => {
            draft.position = position;
            draft.visible = true;
        });
    }

    public hide() {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private async ok_Click() {
        await this.props.onDateSelected!(this.state.selectedDate);
        this.hide();
    }

    private async cancel_Click() {
        await this.props.onDateSelected!(undefined);
        this.hide();
    }

    private getDialogTemplate(): ReactNode {
        return (
            <div className="formgrid grid">
                <div className="col-12 md:col-12">
                    <p>NOTE: 7 days lead time recommended to allow for letter drop to residents/businesses.</p>
                    <br/>
                </div>
                <div className="col-12 md:col-12">
                    <MCalendar id={'noParkingDateSelection'}
                               disabled={false}
                               minDate={new Date()}
                               onChange={this.onDateChange}
                    />
                </div>
            </div>);
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={!this.isOkAvailable()}
                         onClick={this.ok_Click}/>
                <MButton label={'Cancel'}
                         icon={MCancelIconName}
                         disabled={false}
                         onClick={this.cancel_Click}/>
            </div>
        );
    }

    private onDateChange(newValue: Date | undefined) {
        this.safeSetState(
            (draft: State) => draft.selectedDate = newValue);
    }

    private isOkAvailable() {
        return this.state.selectedDate !== undefined;
    }

    /** */
    public render(): ReactElement {

        return (
            <React.Fragment>
                <Dialog title={'Enter No Parking cone install date'}
                        content={this.getDialogTemplate()}
                        icon={{name: 'pi pi-calendar-times', color: 'mcolor-info'}}
                        footer={this.getFooterTemplate()}
                        position={this.state.position}
                        canClose={false}
                        closeOnEscape={false}
                        visible={this.state.visible}
                        onHide={this.dialog_onHide}
                />
            </React.Fragment>

        );

    }

}

export default NoParkingDialog;
